import { axiosClient } from 'api/api';
import { UserQuery } from './UserQueries.api';

export type MyQuery = UserQuery & { ticket_status?: string | null };

export async function listMyQueries(page: number): Promise<{ queries: MyQuery[]; hasMore: boolean }> {
  return (await axiosClient.get('/api/my-queries', { params: { page } })).data.result;
}

/** The member's support query still waiting for support (status Open), if any. While one exists a new query cannot be raised. */
export type PendingQuery = { source: 'concern'; id: number };
export async function getPendingQuery(): Promise<PendingQuery | null> {
  return (await axiosClient.get('/api/my-queries/pending')).data.result.pending;
}
